import { useToastStore } from "@/Components/Toast/store";

export function showSuccessAlert(text: string): void {
  useToastStore.getState().push("success", text);
}

